import { render, staticRenderFns } from "./ReportTotal.vue?vue&type=template&id=6f2f4700&scoped=true&lang=html"
import script from "./ReportTotal.vue?vue&type=script&lang=js"
export * from "./ReportTotal.vue?vue&type=script&lang=js"
import style0 from "./ReportTotal.vue?vue&type=style&index=0&id=6f2f4700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f4700",
  null
  
)

export default component.exports